import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import Box from 'components/Box'
import Divider from 'components/Divider'
import Heading from 'components/Heading'

export default function UnauthBox({
  actions, children, className, title,
}: props) {
  return (
    <Box className={classNames('UnauthBox', className)}>
      <Heading children={title} flush />
      {children}
      {actions &&
        <React.Fragment>
          <Divider className="uk-margin-top" />
          <div className="uk-margin">
            {actions}
          </div>
        </React.Fragment>
      }
    </Box>
  )
}

UnauthBox.propTypes = {
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/UnauthBox/UnauthBox.js